import Navbar from "../../components/navbar/Navbar";
import TodoList from "../../components/todolist/TodoList";

const Todo = () => {
  return (
    <>
      <Navbar />
      <>
        <TodoList />
      </>
    </>
  );
};

export default Todo;
